<div *ngIf="activityForm">
  <div *ngIf="photos?.value?.length > 0" class="dragula-container">
    <ng-container *ngFor="let photo of photos?.controls; let i = index">
      <div class="image-card">
        <div class="image-wrapper">
          <img [src]="getPhotoUrl(photo.value)" />
        </div>
        <div>
          <div class="_1up-outer-wrapper caption">
            <div class="image-card-caption-wrapper">
              <input
                type="text"
                class="text-input caption w-input"
                id="caption-{{ i }}"
                name="caption-{{ i }}"
                placeholder="Enter photo caption..."
                [formControl]="photo.get('caption')"
              />

              <ng-template #photoDeleteTemplate>
                <div class="icon-trash-wrapper caption">
                  <div class="html-embed w-embed">
                    <curbnturf-misc-svg icon="trash"></curbnturf-misc-svg>
                  </div>
                </div>
              </ng-template>

              <curbnturf-delete-confirmation-modal
                [name]="'photo with caption \'' + photo?.value?.caption + '\''"
                [template]="photoDeleteTemplate"
                [deleteFunction]="removePhotoFunction(i)"
              >
              </curbnturf-delete-confirmation-modal>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="activityForm?.valid">
  <curbnturf-image-upload [options]="uploadOptions" [delayedSaveFunction]="activitySave" (beforeUpdating)="save()">
  </curbnturf-image-upload>
</ng-container>
<ng-container *ngIf="!activityForm?.valid">
  <div class="alert-danger">Select a point of interest category or activity before uploading a photo.</div>
</ng-container>
